export const BUDGET_TABS = {
  DETAILS: 1,
  BODYSHOP: 2,
  PARTS: 3,
  TABLES: 4,
  AESTHETICS: 5,
  NOTES: 6,
  ENTRY_CHECKLIST: 7,
  IMAGE_CHECKLIST: 8,
  IMPORT_BUDGET: 9,
};
